import client from './client'

export default {
  /** 标签信息
   * id tag id
   */
  async getTagInfo (id) {
    const url = `/tags/${id}`
    const res = await client.get(url)
    return res && res.data && res.data.data
  },
  /**
   * 标签视频列表
   * @param {*} tagId tag id
   */
  async getTagVideoLIst (tagId) {
    const url = `/tags/${tagId}/videos`
    const res = await client.get(url)
    return res && res.data && res.data.data
  }
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/tag.js